import { SystemEvent, SystemEventLevel } from '@shared-ui/logger-context';

export const CDN_URL = 'https://c.travel-assets.com/advertiser-portal-pwa/';

export const ONBOARDING_DEFAULT_PARTNER_NAME = 'Expedia Ad account';

export enum LOG_EVENT_TYPES {
  INFO_EVENT,
  ONBOARDING_EVENT,
  WARNING_EVENT,
  ERROR_EVENT,
  CRITICAL_EVENT,
  CAP_ERROR,
  CAP_FRUSTRATION,
  GRAPHQL_RETRY_EVENT,
  GRAPHQL_MAX_RETRY_EVENTS_REACHED_EVENT,
  CAP_ACTION,
}

export const LOG_EVENTS = {
  INFO_EVENT: new SystemEvent(SystemEventLevel.INFO, 'INFO_EVENT'),
  ONBOARDING_EVENT: new SystemEvent(SystemEventLevel.INFO, 'ONBOARDING_EVENT'),
  WARNING_EVENT: new SystemEvent(SystemEventLevel.WARN, 'WARNING_EVENT'),
  ERROR_EVENT: new SystemEvent(SystemEventLevel.ERROR, 'ERROR_EVENT'),
  CRITICAL_EVENT: new SystemEvent(SystemEventLevel.CRITICAL, 'CRITICAL_EVENT'),
  CAP_ERROR: new SystemEvent(SystemEventLevel.ERROR, 'CAP_ERROR'),
  CAP_FRUSTRATION: new SystemEvent(SystemEventLevel.WARN, 'CAP_FRUSTRATION'),
  GRAPHQL_RETRY_EVENT: new SystemEvent(SystemEventLevel.INFO, 'GRAPHQL_RETRY_EVENT'),
  GRAPHQL_MAX_RETRY_EVENTS_REACHED_EVENT: new SystemEvent(SystemEventLevel.ERROR, 'GRAPHQL_MAX_RETRY_EVENTS_REACHED'),
  CAP_ACTION: new SystemEvent(SystemEventLevel.INFO, 'CAP_ACTION'),
};

export const TRACE_ID = 'TRACE-ID';

export const ERROR = 'ERROR';

export const JSON_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export const TERMS_CONDITIONS_PROFILE_EXTENSION_PRODUCT = 'sponsored-content-campaign-management';
export const LANGUAGE_PREFERENCES_PROFILE_EXTENSION_PRODUCT = 'sponsored-content-campaign-management';
export const DIRECT_ADVERTISER = 'Direct advertiser';

export const LANGUAGES = [
  { label: 'English (EN)', code: 'EN', locale: 'en_US' },
  { label: 'Español (ES)', code: 'ES', locale: 'es_ES' },
  { label: 'Français (FR)', code: 'FR', locale: 'fr_FR' },
  { label: 'Deutsch (DE)', code: 'DE', locale: 'de_DE' },
  { label: 'Italiano (IT)', code: 'IT', locale: 'it_IT' },
  { label: '日本語 (JP)', code: 'JP', locale: 'ja_JP' },
  { label: '한국어 (KR)', code: 'KR', locale: 'ko_KR' },
];

export const SPONSORED_CONTENT_CAMPAIGN_PRODUCT_ID = 'sponsored-content-campaign-management';
export const UMP_PREFERENCE_API_TENANT_NAME = 'MESO_CAP';

export const HELP_SUPPORT_MAX_TOTAL_SIZE_MB = 25 * 1024 * 1024; // 25MB in bytes
export const MAX_NUMBER_OF_ATTACHMENTS = 5;

export const MAXIMIZE_UNITS = 'maximize-units';
export const MAXIMIZE_CLICKS = 'maximize-clicks';
export const MANUAL_BIDDING = 'manual-bidding';
export const TARGET_ROAS = 'target-return-on-ad-spend';
export const DRIVE_VRBO_BOOKINGS = 'drive-vrbo-bookings';

export const MAXIMIZE_UNITS_TYPENAME = 'MaximizeUnitsCardContent';
export const MAXIMIZE_CLICKS_TYPENAME = 'MaximizeClicksCardContent';
export const MANUAL_BIDDING_TYPENAME = 'ManualBiddingCardContent';
export const TARGET_ROAS_TYPENAME = 'TargetRoasCardContent';

export const VRBO_ADS_TYPE = 'VRBO_ADS';
export const TRAVEL_ADS_TYPE = 'TRAVEL_ADS';

export type CapErrorCategory =
  | 'ERROR_BOUNDARY'
  | 'ERROR_BANNER'
  | 'INVITE_PLUGIN'
  | 'EG_AUTH'
  | 'UNKNOWN'
  | 'GRAPHQL'
  | 'GRAPHQL_RETRY';

export type CapFrustrationCategory = 'GRAPHQL' | 'EXCESSIVE_SPINNER' | 'INFINITE_SPINER';

export const BID_MINIMUM_VALUES = {
  EUR: 0.5,
  USD: 0.5,
  GBP: 0.45,
};

export const DEFAULT_MARKET_LEADER_AVG_ROAS = '1:1';
export const DEFAULT_MARKET_LEADER_AVG_CPC = 'USD 0.00';

/**
 * Comes from
 * https://github.expedia.biz/travel-store/context/blob/master/context-core/src/commonMain/kotlin/com/expediagroup/travelstore/context/resolver/LangIdMapper.kt
 */
export const SITE_RESOLUTION_LOCALE_MAP: { [key: string]: number } = {
  ar_AE: 14337,
  ar_EG: 3073,
  ar_SA: 1025,
  ca_ES: 1027,
  cs_CZ: 1029,
  da_DK: 1030,
  de_AT: 3079,
  de_BE: 6151,
  de_CH: 2055,
  de_DE: 1031,
  el_CY: 4096,
  el_GR: 1032,
  en_AS: 25609,
  en_AU: 3081,
  en_CA: 4105,
  en_CN: 26633,
  en_GB: 2057,
  en_HK: 15369,
  en_ID: 14345,
  en_IE: 6153,
  en_IL: 27657,
  en_IN: 16393,
  en_JP: 23561,
  en_KR: 24585,
  en_LA: 19465,
  en_MX: 28681,
  en_MY: 17417,
  en_NZ: 5129,
  en_PH: 13321,
  en_SG: 18441,
  en_TH: 20489,
  en_TW: 21513,
  en_US: 1033,
  en_VN: 22537,
  en_ZA: 7177,
  es_AR: 11274,
  es_BO: 16394,
  es_BZ: 20490,
  es_CL: 13322,
  es_CO: 9226,
  es_CR: 5130,
  es_EC: 12298,
  es_ES: 3082,
  es_GT: 4106,
  es_GY: 23562,
  es_HN: 18442,
  es_MX: 2058,
  es_NI: 19466,
  es_PA: 6154,
  es_PE: 10250,
  es_PY: 15370,
  es_SV: 17418,
  es_US: 21514,
  es_UY: 14346,
  es_VE: 8202,
  es_XL: 22538,
  et_EE: 1061,
  fi_FI: 1035,
  fr_BE: 2060,
  fr_CA: 3084,
  fr_CH: 4108,
  fr_FR: 1036,
  fr_GF: 7180,
  he_IL: 1037,
  hr_HR: 1050,
  hu_HU: 1038,
  id_ID: 1057,
  in_ID: 1057,
  is_IS: 1039,
  it_CH: 2064,
  it_IT: 1040,
  ja_JP: 1041,
  ko_KR: 1042,
  lb_LU: 1134,
  lt_LT: 1063,
  lv_LV: 1062,
  ms_MY: 1086,
  mt_MT: 1082,
  nb_NO: 1044,
  nl_BE: 2067,
  nl_NL: 1043,
  nl_SR: 3091,
  no_NO_NY: 2068,
  pl_PL: 1045,
  pt_BR: 1046,
  pt_PT: 2070,
  ru_RU: 1049,
  sk_SK: 1051,
  sl_SI: 1060,
  sv_SE: 1053,
  th_TH: 1054,
  tl_PH: 1124,
  tr_TR: 1055,
  uk_UA: 1058,
  vi_VN: 1066,
  zh_CN: 2052,
  zh_HK: 3076,
  zh_TW: 1028,
};

export const VRBO_SITE_ID = 9001001;
